import { initFinanceCalc } from '../components/finance-calc.js';

export function initCreditPage() {
  initFinanceCalc();
}
